// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ao0X","questions":"styles_questions__bSM6j","footer":"styles_footer__tdXaj"};